import { render } from "./ShareForm.vue?vue&type=template&id=586f0c76"
import script from "./ShareForm.vue?vue&type=script&lang=js"
export * from "./ShareForm.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src886087124/src/dt-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__